import enAbout from './en/about.json';
import enCommon from './en/common.json';
import enFooter from './en/footer.json';
import enHome from './en/home.json';
import enConsent from './en/consent.json';
import enContact from './en/contact.json';
import enPrivacy from './en/privacy.json';
import enNavigation from './en/navigation.json';
import enServiceTools from './en/service-tools.json';
import enServiceAgents from './en/service-agents.json';
import enServiceSecureAi from './en/service-secure-ai.json';
import enServiceMigrations from './en/service-migrations.json';
import enServiceImplementations from './en/service-implementations.json';
import plAbout from './pl/about.json';
import plCommon from './pl/common.json';
import plFooter from './pl/footer.json';
import plHome from './pl/home.json';
import plConsent from './pl/consent.json';
import plContact from './pl/contact.json';
import plPrivacy from './pl/privacy.json';
import plNavigation from './pl/navigation.json';
import plServiceTools from './pl/service-tools.json';
import plServiceAgents from './pl/service-agents.json';
import plServiceSecureAi from './pl/service-secure-ai.json';
import plServiceMigrations from './pl/service-migrations.json';
import plServiceImplementations from './pl/service-implementations.json';

export const resources = {
  pl: {
    home: plHome,
    about: plAbout,
    common: plCommon,
    footer: plFooter,
    consent: plConsent,
    contact: plContact,
    privacy: plPrivacy,
    navigation: plNavigation,
    'service-tools': plServiceTools,
    'service-agents': plServiceAgents,
    'service-secure-ai': plServiceSecureAi,
    'service-migrations': plServiceMigrations,
    'service-implementations': plServiceImplementations,
  },
  en: {
    home: enHome,
    about: enAbout,
    common: enCommon,
    footer: enFooter,
    consent: enConsent,
    contact: enContact,
    privacy: enPrivacy,
    navigation: enNavigation,
    'service-tools': enServiceTools,
    'service-agents': enServiceAgents,
    'service-secure-ai': enServiceSecureAi,
    'service-migrations': enServiceMigrations,
    'service-implementations': enServiceImplementations,
  },
};

type AppResources = (typeof resources)['pl'];

export type ServiceNamespace = Extract<keyof AppResources, `service-${string}`>;
